<div class="modal" (click)="clickOuside()">
    <div class="modal-content" (click)="stopPropagation($event)">
        <div class="modal-header"> {{ header }} </div>
        <div class="modal-body">
            <div class="msg-wrapper">{{ msg }}</div>
            <div class="msg-details-wrapper" *ngIf="errorDetails && errorDetails !== ''">
                <div class="button" (click)="showDetails = !showDetails">
                    <div class="icon" [ngClass]="{ 'active': showDetails }"></div>
                    <p>Afficher plus de détails</p>
                </div>
                <div class="msg" *ngIf="showDetails">{{ errorDetails }}</div>
            </div>
            <div class="button-wrapper">
                <frg-button (activated)="closeAlertModal()" [backgroundColor]="'var(--darkest-primary)'">
                    Fermer</frg-button>
                <frg-button *ngIf="buttonText" (activated)="closeAlertModal(true)">{{ buttonText }}</frg-button>
            </div>
        </div>
    </div>
</div>
<div class="modal-background"></div>